import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

interface Props {
  showBorder?: boolean
  children: React.ReactNode
}

export const Wrapper = ({ showBorder, children }: Props) => {
  if (showBorder) {
    return (
      <Box
        background="white"
        borderRadius={{ all: 'abs006' }}
        border={{
          all: {
            width: 's1',
            style: 'solid',
            color: 'grey400',
          },
        }}
      >
        {children}
      </Box>
    )
  }
  return <Box background="white">{children}</Box>
}
